import { has, path } from 'ramda'

const hasMetaProperty = has('meta')

export default function extractValidationErrorMessage(answer) {
  if (!hasMetaProperty(answer)) {
    return null;
  }
  return path([ 'meta', 'validationErrorMessage' ], answer)
}



// WEBPACK FOOTER //
// ./src/components/questionnaire/validators/validationErrorMessageExtractor.js